/**
 * Auth Layout Component (for login page)
 */
import { Box, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { palette } from '../../theme/palette';

const AuthLayout = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.mode === 'dark'
          ? palette.dark.background
          : `linear-gradient(135deg, ${palette.brand[50]} 0%, ${palette.brandSecondary[50]} 100%)`,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: { xs: '100%', sm: '100%', md: '100%', lg: 600 },
          height: '100%',
          p: { xs: 2, sm: 3, md: 4 },
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AuthLayout;

